// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1eOA8","productName":"Table_productName__En-mE"};